import type { RouteRecordRaw } from 'vue-router'
import Invest from '@/views/frontDesk/company/invest.vue'
import Bbs from '@/views/frontDesk/company/bbs.vue'
import Room from '@/views/frontDesk/company/room.vue'
import Detail from '@/views/frontDesk/company/detail.vue'

// 企业
export const CompanyRoute: Array<RouteRecordRaw> = [
  {
    path: 'invest/:id',
    name: 'Invest',
    meta: {
      title: '会员-楼盘招商' 
    },
    component: Invest
  },
  {
    path: 'bbs/:id',
    name: 'Bbs',
    meta: {
      title: '会员-社区营销' 
    },
    component: Bbs
  },
  {
    path: 'room/:id',
    name: 'Room',
    meta: {
      title: '会员-样板房' 
    },
    component: Room
  },
  {
    path: 'detail/:id',
    name: 'Detail',
    meta: {
      title: '会员-企业信息' 
    },
    component: Detail
  }
]

export default CompanyRoute